// CRFTOP theme.js — marketing wheel, before/after slider, airform strands
(function(){
  // ==== MARKETING WHEEL ====
  var overlay = document.getElementById('mwOverlay');
  if (overlay) {
    var prizes = [
      { label: '5% OFF',    code: 'CRFTOP5',  color: '#FFF8EF', tx: '#2A1810' },
      { label: '10% OFF',   code: 'CRFTOP10', color: '#FF6A13', tx: '#FFF8EF' },
      { label: 'Try again', code: null,       color: '#F6EEDF', tx: '#2A1810' },
      { label: '15% OFF',   code: 'CRFTOP15', color: '#2A1810', tx: '#FFF8EF' },
      { label: 'Free gift', code: 'GIFTKP',   color: '#3D4A3A', tx: '#FFF8EF' },
      { label: 'Try again', code: null,       color: '#F6EEDF', tx: '#2A1810' },
      { label: '20% OFF',   code: 'CRFTOP20', color: '#FF6A13', tx: '#FFF8EF' },
      { label: 'Free ship', code: 'FREESHIP', color: '#2A1810', tx: '#FFF8EF' }
    ];
    var weights = [18, 30, 6, 24, 4, 6, 2, 10];
    var svg = document.getElementById('wheelSvg');
    var slicesG = document.getElementById('wheelSlices');
    var n = prizes.length;
    var step = 360 / n;
    for (var i = 0; i < n; i++) {
      var a0 = -90 + i * step - step/2;
      var a1 = -90 + i * step + step/2;
      var r = 98;
      var x0 = r * Math.cos(a0 * Math.PI/180);
      var y0 = r * Math.sin(a0 * Math.PI/180);
      var x1 = r * Math.cos(a1 * Math.PI/180);
      var y1 = r * Math.sin(a1 * Math.PI/180);
      var path = 'M 0 0 L ' + x0.toFixed(2) + ' ' + y0.toFixed(2) + ' A ' + r + ' ' + r + ' 0 0 1 ' + x1.toFixed(2) + ' ' + y1.toFixed(2) + ' Z';
      var slice = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      slice.setAttribute('d', path);
      slice.setAttribute('fill', prizes[i].color);
      slice.setAttribute('stroke', '#2A1810');
      slice.setAttribute('stroke-width', '0.8');
      slicesG.appendChild(slice);
      var la = -90 + i * step;
      var lx = 62 * Math.cos(la * Math.PI/180);
      var ly = 62 * Math.sin(la * Math.PI/180);
      var txt = document.createElementNS('http://www.w3.org/2000/svg', 'text');
      txt.setAttribute('x', lx.toFixed(2));
      txt.setAttribute('y', ly.toFixed(2));
      txt.setAttribute('text-anchor', 'middle');
      txt.setAttribute('dominant-baseline', 'middle');
      txt.setAttribute('transform', 'rotate(' + (la + 90) + ' ' + lx.toFixed(2) + ' ' + ly.toFixed(2) + ')');
      txt.setAttribute('fill', prizes[i].tx);
      txt.setAttribute('font-family', 'Montserrat, sans-serif');
      txt.setAttribute('font-weight', '800');
      txt.setAttribute('font-size', '8');
      txt.textContent = prizes[i].label;
      slicesG.appendChild(txt);
    }
    function hide() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      try { localStorage.setItem('crftop-wheel-seen', '1'); } catch(e){}
    }
    function show() {
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    document.getElementById('mwClose').addEventListener('click', hide);
    document.getElementById('mwSkip').addEventListener('click', hide);
    overlay.addEventListener('click', function(e){ if (e.target === overlay) hide(); });
    var form = document.getElementById('mwForm');
    if (form) form.addEventListener('submit', function(e){
      e.preventDefault();
      var email = document.getElementById('mwEmail').value;
      if (!email) return;
      document.getElementById('mwEmailEcho').textContent = email;
      var total = weights.reduce(function(a,b){return a+b;},0);
      var rv = Math.random() * total, idx = 0;
      for (var k = 0; k < n; k++) { rv -= weights[k]; if (rv <= 0) { idx = k; break; } }
      var picked = prizes[idx];
      var target = idx * step;
      var finalRot = 360 * 5 - target + (Math.random() * (step * 0.6) - step * 0.3);
      svg.style.transform = 'rotate(' + finalRot + 'deg)';
      setTimeout(function(){
        document.getElementById('mwPrize').textContent = picked.label.toUpperCase();
        document.getElementById('mwCode').textContent = picked.code || 'Try next time';
        document.getElementById('mwIntro').style.display = 'none';
        document.getElementById('mwResult').classList.add('is-on');
      }, 5200);
    });
    var code = document.getElementById('mwCode');
    if (code) code.addEventListener('click', function(){
      var txt = code.textContent;
      if (txt === 'Try next time') return;
      if (navigator.clipboard) navigator.clipboard.writeText(txt);
      code.textContent = 'Copied!';
      setTimeout(function(){ code.textContent = txt; }, 1200);
    });
    try {
      var seen = localStorage.getItem('crftop-wheel-seen');
      var delay = parseInt(overlay.getAttribute('data-delay'), 10) || 2000;
      if (!seen) setTimeout(show, delay);
    } catch(e) {}
  }

  // ==== AIRFORM STRANDS ====
  var stage = document.getElementById('afstage');
  if (stage && 'IntersectionObserver' in window) {
    var played = false;
    function animSafe(s) {
      Array.prototype.forEach.call(s, function(el, i){
        var amp = 14 + (i % 4) * 4;
        var rot = amp * 0.18;
        var dur = 1800 + (i % 3) * 220;
        el.animate([
          { transform: 'translateX(0) rotate(0deg)' },
          { transform: 'translateX(' + amp + 'px) rotate(' + rot + 'deg)', offset: 0.5 },
          { transform: 'translateX(' + (-amp*0.4) + 'px) rotate(' + (-rot*0.5) + 'deg)' }
        ], { duration: dur, delay: i * 70, iterations: Infinity, direction: 'alternate' });
      });
    }
    function animDmg(s) {
      Array.prototype.forEach.call(s, function(el, i){
        var amp = 25 + (i % 5) * 7;
        var rot = 8 + (i % 4) * 3;
        var skew = 6 + (i % 3) * 5;
        var sy = 0.82 - (i % 4) * 0.05;
        var dur = 800 + (i % 3) * 180;
        el.animate([
          { transform: 'translateX(0) rotate(0deg) skewX(0deg) scaleY(1)', opacity: 0.8 },
          { transform: 'translateX(' + amp + 'px) rotate(' + rot + 'deg) skewX(' + skew + 'deg) scaleY(' + sy + ')', opacity: 0.4, offset: 0.5 },
          { transform: 'translateX(' + (-amp*0.5) + 'px) rotate(' + (-rot*0.7) + 'deg) skewX(' + (-skew*0.6) + 'deg) scaleY(' + (sy*0.85) + ')', opacity: 0.25 }
        ], { duration: dur, delay: i * 50, iterations: Infinity, direction: 'alternate' });
      });
    }
    new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting && !played) {
          played = true;
          animSafe(stage.querySelectorAll('.safe .strand'));
          animDmg(stage.querySelectorAll('.damage .strand'));
        }
      });
    }, { threshold: 0.3 }).observe(stage);
  }

  // ==== BEFORE/AFTER SLIDER ====
  var ba = document.getElementById('baSlider');
  if (ba) {
    var after = ba.querySelector('.after');
    var handle = ba.querySelector('.handle');
    var pct = 50;
    function set(p) {
      pct = Math.max(0, Math.min(100, p));
      after.style.clipPath = 'polygon(0 0, ' + pct + '% 0, ' + pct + '% 100%, 0 100%)';
      handle.style.left = pct + '%';
      ba.setAttribute('aria-valuenow', Math.round(pct));
    }
    function onMove(x) {
      var rect = ba.getBoundingClientRect();
      set(((x - rect.left) / rect.width) * 100);
    }
    var dragging = false;
    ba.addEventListener('pointerdown', function(e){ dragging = true; try { ba.setPointerCapture(e.pointerId); } catch(_){} onMove(e.clientX); });
    ba.addEventListener('pointermove', function(e){ if (dragging) onMove(e.clientX); });
    ba.addEventListener('pointerup', function(){ dragging = false; });
    ba.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft') set(pct - 5);
      if (e.key === 'ArrowRight') set(pct + 5);
    });
    set(50);
  }
})();
